import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';



const InputArea = ({ type = 'text', placeholder = '', value, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div className="relative w-full">
      <input
        type={inputType}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required
        className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-red-600 pr-12"
      />
      {isPassword && (
        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute inset-y-0 right-3 flex items-center text-sm text-gray-600 hover:text-gray-800"
        >
          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      )}
    </div>
  );
};

export default InputArea;


const InputField = ({ label, width = 'w-64', type = "text", className, value, onChange, placeholder, step }) => (
  <div className={`flex flex-col ${className} mb-4 ${width}`}>
    <label className="font-semibold text-gray-700">{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      step={step}
      className="border border-gray-300 rounded px-3 h-[40px] py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
    />
  </div>
);

const SmallInputField = ({ label, width = 'w-full', type = "text", className = "", value, onChange, placeholder, step, readOnly }) => (
  <div className={`flex flex-col ${className} mb-1 ${width}`}>
    <label className="text-[15px] font-medium underline text-gray-600 mb-0.5">{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      step={step}
      readOnly={readOnly}
      className="border border-gray-300 rounded px-1.5 h-6 text-[11px] focus:outline-none focus:ring-1 focus:ring-red-400"
    />
  </div>
);

export { InputArea, InputField, SmallInputField };
